<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-17 15:01:46
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-05 18:01:58
 -->
<!--  -->
<template>
  <div class="easyForm" >
      <el-dialog
      class="avue-dialog"
      v-dialogDrag
      ref="dialog__wrapper"
      v-if="easyFormInfo.header"
      :title="easyFormInfo.header.title?easyFormInfo.header.title:'请为弹窗取个名字呀'"
      :visible.sync="easyFormInfo.header.show"
      :width="easyFormInfo.header.width * fighterScale"
      :top="easyFormInfo.header.marginTop || '10vh'"
      :fullscreen="easyFormInfo.header.fullscreen"
      :show-close="easyFormInfo.header.showClose === false ? false : true "
      :close-on-click-modal="easyFormInfo.header.CloseOnClickModal === false ? false : true"
      style="min-width:31.25rem"
      append-to-body
      lock-scroll
      :modal-append-to-body="false"
      @close="dilogClose"
    >
    <el-scrollbar  :style="easyFormInfo.header.fullscreen?'height:100%;':'height:28.125rem;'+'padding:0px;'">
        <!-- 主体区域 -->
      <el-form
        class="avue-form"
        style="margin:0px 0.3125rem 0px 0px;"
        v-if="easyFormInfo.form"
         label-suffix=":"
        :model="easyFormInfo.data"
        ref="easyForm"
        :label-width=" (!easyFormInfo.form.labelWidth || easyFormInfo.form.labelWidth == 'auto')?'6.25rem':easyFormInfo.form.labelWidth * fighterScale"
        :inline="false"
        :label-position="easyFormInfo.form.labelPosition||'right'"
      >
        <el-row :gutter="10"  v-if="easyFormInfo.form.formItems && easyFormInfo.form.formItems !==0">
            <el-col   v-for="(item,index) in easyFormInfo.form.formItems"
                :xl="item.span||12"
                :lg="item.span||12"
                :md="24"
                :sm="24"
                :xs="24"
                :key="index">
            <el-form-item
            v-if="item.display !== false"
              :label="item.label||'未命名字段'"
              :prop="item.prop"
              :rules="item.rules"
              :required="item.required"
            >
             <component
             v-if="!item.formslot"
                :is="getComponent(item.type, item.component)"
                :dataType="item.dataType"
                :clearable="item.clearable"
                :filterable="item.filterable === false?false:true"
                :disabled="item.disabled"
                :format="item.format"
                :multiple="item.multiple"
                :label="item.label"
                :minRows="item.minRows"
                :maxRows="item.maxRows"
                :precision="item.precision"
                :prop="item.prop"
                :placeholder="getPlaceholder(item)"
                :readonly="item.readonly"
                :startPlaceholder="item.startPlaceholder"
                :tip="item.tip"
                :type="item.type"
                :display="item.display"
                :valueDefault="item.valueDefault"
                :tags='true'
                :value-format="item.valueFormat"
                :min="item.min"
                :max="item.max"
                :minlength="item.minlength"
                :maxlength="item.maxlength"
                :size="item.size || 'medium'"
                :append="item.append"
                :dic="item.dicData"
                :border="item.border"
                :prepend="item.prepend"
                :showWordLimit="item.showWordLimit"
                :controls-position="item.controlsPosition"
                v-model.trim="easyFormInfo.data[item.prop]"
                @change="valchange(item)"
                />
                <slot v-else :name="item.prop" :prop="item.prop" :easyFormInfo="easyFormInfo" :disabled="item.disabled" :data="easyFormInfo.data" :label="item.label" ></slot>
            </el-form-item>
            </el-col>
        </el-row>
        </el-form>
         <!-- 表格插槽 -->
        <el-row v-if="easyFormInfo.form && easyFormInfo.form.slotName">
            <el-col :span="24" >
                    <slot   :data="easyFormInfo.data" :name="easyFormInfo.form.slotName"></slot>
            </el-col>
        </el-row>
        <!-- 按钮组 -->
    </el-scrollbar>
    <el-row>
        <el-col :span ="24">
            <div class="avue-form__menu avue-form__menu--center" style="margin-top:10px;">
                 <el-button v-for="(item,index)  in easyFormInfo.formButton"
                 :key="index"
                 size="medium"
                 :loading="item.loading"
                 :type="item.type || 'primary'"
                 @click="Handle(item.clickEvent,easyFormInfo.data,item.validate,item.note,easyFormInfo)"
                 >{{item.buttonName}}</el-button>
                <el-button size="medium" type="info" @click="easyFormInfo.header.show =false">取 消</el-button>
            </div>
        </el-col>
    </el-row>
    </el-dialog>
  </div>
</template>

<script>

import { deepClone } from '@/framework/util/util.js'

export default {
  data() {
    return {
      fighterScale: 1, // 当前屏幕与标准屏幕比值
      oldData: {}
    }
  },
  props: ['easyFormInfo'],
  watch: {
    'easyFormInfo.header.show'(newValue, oldValue) {
      if (newValue !== false) {
        this.oldData = deepClone(this.easyFormInfo.data)
        this.easyFormInfo.form.formItems.forEach(item => {
          item.rules = this.getRules(item)
        })
      }
    }
  },
  created() {
    this.fighterScale = window.fighterScale
  },
  methods: {
    /** 打开回调 */
    dilogClose: function() {
      this.resetmyForm()
      this.easyFormInfo.data = {}
    },
    /** * 关闭回调 */
    change: function() {
      this.$forceUpdate()
    },
    Handle(e, formName, validate, note, easyFormInfo) {
      if (validate !== false) {
        // 数据验证
        this.$refs.easyForm.validate((valid, invalidFields) => {
          if (valid) {
            this.$emit(e, deepClone(formName), note, easyFormInfo, this.oldData)
          } else {
            let invalidFieldsKeys = Object.keys(invalidFields)
            if (invalidFieldsKeys.length) {
              // let fields = this.$refs.easyForm.fields
              let target = this.$refs.easyForm.fields.filter(item => item.labelFor === invalidFields[invalidFieldsKeys[0]][0].field)
              if (target.length) {
                target[0].$el.scrollIntoView({ behavior: 'smooth' })
              }
            }
          }
        })
      } else {
        this.$emit(e, deepClone(formName), note, easyFormInfo, this.oldData)
      }
    },
    resetmyForm() {
      this.$refs.easyForm.resetFields()
    },
    /**
     * @description 根据字段类型或组件名称,返回应加载的组件名称
     * @param {string} type 类型
     * @param {string} component 组建名
     */
    getComponent: function(type, component) {
      let KEY_COMPONENT_NAME = 'avue-'
      let result = 'input'
      if (!this.validatenull(component)) {
        return component
      } else if (type === 'select') {
        result = 'select'
      } else if (type === 'radio') {
        result = 'radio'
      } else if (type === 'checkbox') {
        result = 'checkbox'
      } else if (['time', 'timerange'].includes(type)) {
        result = 'time'
      } else if (
        [
          'dates',
          'date',
          'datetime',
          'datetimerange',
          'daterange',
          'week',
          'month',
          'year'
        ].includes(type)
      ) {
        result = 'date'
      } else if (type === 'number') {
        result = 'input-number'
      } else if (type === 'password') {
        result = 'input'
      } else if (type === 'switch') {
        result = 'switch'
      } else if (type === 'rate') {
        result = 'rate'
      } else if (type === 'slider') {
        result = 'slider'
      } else if (type === 'color') {
        result = 'color'
      }
      return KEY_COMPONENT_NAME + result
    },
    /**
     * @description 获取提示字符串
     * @param {Object} column 列配置
     */
    getPlaceholder(column) {
      if (column.placeholder) {
        return column.placeholder
      }
      const label = column.label
      if (['select', 'checkbox', 'radio', 'color', 'date', 'time'].includes(column.type)) {
        return `请选择${label}`
      } else {
        return `请输入${label}`
      }
    },
    /**
     * 获取提示信息
     */
    getRules: function(item) {
      if (item.required) {
        if (!Array.isArray(item.rules)) {
          item.rules = []
        }
        if (['select', 'checkbox', 'radio', 'color', 'date', 'time'].includes(item.type)) {
          item.rules.push({ 'required': true, 'message': `请选择${item.label}` })
        } else {
          item.rules.push({ 'required': true, 'message': `请输入${item.label}` })
        }
      }
      return item.rules || []
    },
    valchange: function(item) {
      typeof item.onChange === 'function' && item.onChange(item, this.easyFormInfo.data[item.prop], this.easyFormInfo)
    }
  }
}

</script>
<style lang='scss' scoped>
.el-form-item__content>.el-select{
        width:100%;
}
.el-is-horizontal{
  display:none!important;
}
</style>
